import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/index.css';
import './styles/theme.css';
import './styles/global.css';
import { sthenusTheme } from './theme/sthenusTheme';
import * as Sentry from '@sentry/react';
import LogRocket from 'logrocket';
import { AuthProvider } from './app/providers/AuthProvider';
import App from './App';
import { ConfigProvider } from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(customParseFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
dayjs.extend(advancedFormat);
dayjs.locale('es');

if (process.env.REACT_APP_LOGROCKET_ENABLED === 'true') {
  LogRocket.init(process.env.REACT_APP_LOGROCKET_APP);
}

if (process.env.REACT_APP_SENTRY_ENABLED === 'true') {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ConfigProvider theme={sthenusTheme}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ConfigProvider>
  </React.StrictMode>,
);
